import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  image: string;
  quote: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  location,
  image,
  quote
}) => {
  return <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100" data-id="element-212">
      <QuoteIcon className="h-8 w-8 text-[#FF4E00] mb-4" data-id="element-213" />
      <p className="text-gray-700 mb-6 italic" data-id="element-214">"{quote}"</p>
      <div className="flex items-center" data-id="element-215">
        <img src={image} alt={name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-216" />
        <div data-id="element-217">
          <h4 className="font-bold text-gray-800" data-id="element-218">{name}</h4>
          <p className="text-gray-600 text-sm" data-id="element-219">{location}</p>
        </div>
      </div>
    </div>;
};
export default TestimonialCard;